import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-page-edit-address',
    templateUrl: './page-edit-address.component.html',
    styleUrls: ['./page-edit-address.component.scss'],
    standalone: true,
    imports: [FormsModule]
})
export class PageEditAddressComponent {
    constructor() { }
}
